/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useDispatch } from 'react-redux';
import { func } from 'prop-types';

import { Button, Dialog } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { trackEvent } from '../../../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const useStyles = makeStyles(
    (theme) => ({
        root: {
            textAlign: 'center',
            padding: '16px',
            fontSize: '0.875em',
            '& button': {
                fontSize: '1em',
            },
        },
        headerModalText: {
            textAlign: 'center',
            fontWeight: '700',
            marginBottom: '16px',
            fontSize: '1em',
        },
        rootDialog: {
            marginTop: '0',
            top: '80px',
            position: 'absolute',
        },
        btnYes: {
            textTransform: 'none',
            backgroundColor: theme.palette.buttonBackgroundColor,
            color: theme.palette.primary?.contrastText,
            fontSize: '1em',
            fontWeight: 'bold',
            margin: '5px',
            width: '120px',
            height: 40,
            '&:hover, &:focus, &:active': {
                backgroundColor: theme.palette.primary?.contrastText,
                color: theme.palette.buttonBackgroundColorSecondary,
                border: `1px solid ${theme.palette.buttonBackgroundColorSecondary}`,
            },
        },
        btnNo: {
            textTransform: 'none',
            backgroundColor: theme.palette.white,
            border: `1px solid ${theme.palette.buttonBackgroundColor}`,
            color: theme.palette.buttonBackgroundColor,
            fontSize: '1em',
            fontWeight: 'bold',
            margin: '5px',
            width: '120px',
            height: 40,
            '&:hover, &:focus, &:active': {
                border: `1px solid ${theme.palette.buttonBackgroundColorSecondary}`,
                color: theme.palette.buttonBackgroundColorSecondary,
            },
        },
    }),
    { name: 'CloseCalendarConsent' },
);

const CloseCalendarConsent = ({
    closeModal,
    saveDate,
}) => {
    const dispatchAction = useDispatch();
    const classes = useStyles();
    return (
        <Dialog
            open
            classes={{
                paper: classes.rootDialog,
            }}
        >
            <div className={classes.root}>
                <div className={classes.headerModalText}>Would you like to save your delivery date changes?</div>
                <Button
                    id="btn-calendar-consent-save"
                    name="btnCalendarConsentSave"
                    className={classes.btnYes}
                    color="primary"
                    aria-label="Yes Save date"
                    onClick={saveDate}
                >
                    Yes
                </Button>
                <Button
                    id="btn-calendar-consent-close"
                    name="btnCalendarConsentClose"
                    className={classes.btnNo}
                    color="primary"
                    aria-label="Do not save date"
                    onClick={() => {
                        dispatchAction(
                            trackEvent({
                                eventName: 'feature_interaction',
                                eventCategory: 'Checkout',
                                eventAction: 'Calendar',
                                eventLabel: 'Confirm Close Modal Displayed',
                            }),
                        );
                        closeModal();
                    }}
                >
                    No
                </Button>
            </div>
        </Dialog>
    );
};

CloseCalendarConsent.propTypes = {
    closeModal: func.isRequired,
    saveDate: func.isRequired,
};

export default CloseCalendarConsent;
